var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('router-view'),_c('UpdateNotification',{attrs:{"text":_vm.$t('app.updateAvailable'),"button-text":_vm.$t('app.update')}}),_c('Footer'),_c('Notifier')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }